
(() => {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.loaded) return;

      if (this.topUp) { this.load(); return; }
      if (this.primary) { this.load(); return; }

      const rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight + 400 && rect.bottom > -400) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this);
    }

    get topUp() {
      return this.dataset.topUp !== undefined;
    }

    get primary() {
      return this.dataset.primary !== undefined;
    }

    async load() {
      this.loaded = true;
      try {
        let html = await this.fetchFor(this.dataset.url);

        if (!html && this.dataset.noFallback === undefined
            && this.dataset.url.includes('intent=complementary')) {
          html = await this.fetchFor(this.dataset.url.replace('intent=complementary', 'intent=related'));
        }

        if (this.topUp) { if (html) this.appendTo(html); else this.remove(); return; }

        if (html === null) { console.warn('[recommendations] запит не вдався', this.dataset.url); this.empty(); return; }
        if (!html) { this.empty(); return; }

        const tpl = document.createElement('template');
        tpl.innerHTML = html;

        if (this.dataset.sliderOptions) {
          tpl.content.querySelectorAll('embla-slider').forEach((s) => s.setAttribute('data-options', this.dataset.sliderOptions));
        }
        if (this.dataset.title) {
          tpl.content.querySelectorAll('.reco-band__title, .recommendations__title')
            .forEach((h) => { h.textContent = this.dataset.title; });
        }
        this.replaceChildren(tpl.content);

        if (this.primary) this.closest('.product-reco')?.classList.add('has-primary');
      } catch (e) {
        console.error('[recommendations]', e);
        this.empty();
      }
    }

    empty() {
      if (this.primary) {
        const section = this.closest('.shopify-section');
        if (section) section.style.display = 'none';
      }
      this.remove();
    }

    async fetchFor(url) {
      const tries = this.primary ? 3 : 1;
      for (let i = 0; i < tries; i += 1) {
        let res = null;
        try { res = await fetch(url); } catch (_) { res = null; }
        if (res && res.ok) {
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = doc.querySelector('product-recommendations');
          if (!fresh || !fresh.innerHTML.trim()) return '';

          if (this.primary && !fresh.querySelector('.embla__slide')) return '';
          return fresh.innerHTML;
        }

        if (res && res.status !== 429 && res.status < 500) return '';
        if (i + 1 < tries) await new Promise((r) => setTimeout(r, 1500 * (i + 1)));
      }
      return this.primary ? null : '';
    }

    appendTo(html) {
      const slider = this.closest('.reco-band')?.querySelector('embla-slider');
      const box = slider?.querySelector('.embla__container');
      if (!box) { this.remove(); return; }
      const need = Math.max(0, Number(this.dataset.topUp) - box.children.length);
      const seen = new Set([...box.querySelectorAll('[data-handle]')].map((c) => c.dataset.handle));
      const tpl = document.createElement('template');
      tpl.innerHTML = html;
      let added = 0;
      for (const slide of tpl.content.querySelectorAll('.embla__slide')) {
        if (added >= need) break;
        const handle = slide.querySelector('[data-handle]')?.dataset.handle;
        if (!handle || seen.has(handle)) continue;
        seen.add(handle);
        slide.classList.add('buy-with-carousel__slide');
        box.appendChild(slide);
        added += 1;
      }
      if (added) slider.refresh?.();
      this.remove();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
